import { createAsyncThunk } from "@reduxjs/toolkit";
import { getImageSignaturesAPI, getLoginSectionsAPI } from "./auth.service";
import { AxiosError } from "axios";
import { mapImageSignatureFields, mapProgramFields } from "./types";

export const authThunk = {
  getLoginSections: createAsyncThunk(
    "getLoginSections",
    async (_, thunkApi) => {
      try {
        const response = await getLoginSectionsAPI();
        const data = await mapProgramFields(response.data);

        return thunkApi.fulfillWithValue(data);
      } catch (error) {
        const err = error as AxiosError;

        return thunkApi.rejectWithValue(err.response?.status);
      }
    }
  ),

  getImageSignatures: createAsyncThunk(
    "getImageSignatures",
    async (_, thunkApi) => {
      try {
        const response = await getImageSignaturesAPI();
        const data = await mapImageSignatureFields(response.data);

        return thunkApi.fulfillWithValue(data);
      } catch (error) {
        const err = error as AxiosError;

        return thunkApi.rejectWithValue(err.response?.status);
      }
    }
  ),
};
